import { Divider, Grid, Typography } from "@mui/material";

import { LabelStyle } from "../../components/LabelStyle";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";

SensorInfoGrid.propTypes = {
    acquisitionVector: PropTypes.shape(MODEL_PROPTYPES.AcquisitionVector)
        .isRequired,
    focalLength35mmEqv: PropTypes.number,
    rawDataset: PropTypes.shape(MODEL_PROPTYPES.RawDatasets),
};

export function SensorInfoGrid({
    acquisitionVector,
    focalLength35mmEqv,
    rawDataset,
}) {
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid size={4}>
                <LabelStyle>Acquisition vector</LabelStyle>
            </Grid>
            <Grid size={8}>{acquisitionVector.name}</Grid>
            <Grid size={4}>
                <LabelStyle>System</LabelStyle>
            </Grid>
            <Grid size={8}>{acquisitionVector.SystemModel.system}</Grid>
            <Grid size={4}>
                <LabelStyle>System model</LabelStyle>
            </Grid>
            <Grid size={8}>{acquisitionVector.SystemModel.name}</Grid>
            <Grid size={4}>
                <LabelStyle>Serial number</LabelStyle>
            </Grid>
            <Grid size={8}>{rawDataset?.metadata?.serial_number ?? "-"}</Grid>
            <Grid size={4}>
                <LabelStyle>Camera model</LabelStyle>
            </Grid>
            <Grid size={8}>{rawDataset?.metadata?.camera_model ?? "-"}</Grid>
            {acquisitionVector.SensorBundles.length === 1 ? (
                <Grid container spacing={1} alignItems="center">
                    <Grid size={4}>
                        <LabelStyle>Sensor</LabelStyle>
                    </Grid>
                    <Grid size={8}>
                        {acquisitionVector.SensorBundles[0].Sensor.name}
                    </Grid>

                    <Grid size={4}>
                        <LabelStyle>Data type</LabelStyle>
                    </Grid>
                    <Grid size={8}>
                        {acquisitionVector.SensorBundles[0].Sensor.dataType}
                    </Grid>

                    <Grid size={4}>
                        <LabelStyle>Focal length 35mm eqv</LabelStyle>
                    </Grid>
                    <Grid size={8}>
                        {acquisitionVector.SensorBundles[0].Sensor
                            .focalLength35mmEqv ?? focalLength35mmEqv}{" "}
                        mm
                    </Grid>
                </Grid>
            ) : (
                acquisitionVector.SensorBundles.map((bundle) => (
                    <Grid
                        container
                        spacing={1}
                        alignItems="center"
                        key={bundle.uuid}
                    >
                        <Grid size={12}>
                            <Divider />
                        </Grid>
                        <Grid size={12}>
                            <Typography color={"black"} fontWeight={"bold"}>
                                {bundle.Sensor.name}
                            </Typography>
                        </Grid>

                        <Grid size={4}>
                            <LabelStyle>Data type</LabelStyle>
                        </Grid>
                        <Grid size={8}>{bundle.Sensor.dataType}</Grid>

                        <Grid size={4}>
                            <LabelStyle>Focal length 35mm eqv</LabelStyle>
                        </Grid>
                        <Grid size={8}>
                            {bundle.Sensor.focalLength35mmEqv ??
                                focalLength35mmEqv}{" "}
                            mm
                        </Grid>
                    </Grid>
                ))
            )}
        </Grid>
    );
}
